<div class="map" id="{{uniqId + '-map'}}" [class.add-map-marker-mode]="AddMarkerMode"></div>
<app-loading *ngIf="(loadBackgroundLayer$ | async) || (loadScreenshot$ | async)"></app-loading>
<ng-template #mapMarkerTemplate>
    <fa-icon icon="location-dot"></fa-icon>
</ng-template>
